import { Box, FormControlLabel, Stack, Switch, TableRow } from '@mui/material';
import * as S from './TableTitle.styled';
import { RowsPerPageSelector } from './RowsPerPageSelector';
import { TableTitlePropsType } from './TableTitle.types';
import { capitalize, isVowel } from '@shared';

export const TableTitle = ({
  length = 1,
  entityName,
  rowsPerPage = undefined,
  onRowsPerPageChange = undefined,
  filterByAuditOfInterest = undefined,
  isAuditOfInterest = undefined,
}: TableTitlePropsType) => {
  const title = `Select ${isVowel(entityName[0]) ? 'an' : 'a'}
  ${capitalize(entityName)}`;
  const withSelector = rowsPerPage && onRowsPerPageChange;
  return (
    <TableRow sx={{ height: 40 }}>
      <S.TableTitleCell colSpan={length}>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
          <S.TableTitle>{title}</S.TableTitle>
          <Box display='flex' gap={4} alignItems='center'>
            {filterByAuditOfInterest && (
              <FormControlLabel
                value='start'
                checked={isAuditOfInterest}
                control={<Switch color='primary' />}
                label={<strong>Audit of Interest</strong>}
                labelPlacement='start'
                onChange={(_, checked) => filterByAuditOfInterest(checked)}
              />
            )}
            {withSelector && (
              <RowsPerPageSelector
                entityName={entityName}
                value={rowsPerPage}
                handleChange={onRowsPerPageChange}
              />
            )}
          </Box>
        </Stack>
      </S.TableTitleCell>
    </TableRow>
  );
};
